export function setLoginTitle(): void {
  [
    'title',
    '.header .headline'
  ].forEach((selector) => {
    document.querySelector<HTMLElement>(selector).innerText = 'TrackFree Abo Check'
  })
}
